module.exports = __webpack_public_path__ + "static/media/donbosco7.67187ac6.jpg";